/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Ujjwal Agarwal",
  title: "Hi all, I'm Ujjwal",
  subTitle: emoji(
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact."
  ),
  resumeLink:
    "https://www.notion.so/Resume-cd4d82270834408f8d3d4fb2fa349497",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/specter25",
  linkedin: "https://www.linkedin.com/in/agarwalujjwal012/",
  gmail: "agarwalujjwal012@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/ujjwal.agarwal.758/",
  instagram: "https://www.instagram.com/ujjwal_agarwal13/?hl=en",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "MERN Stack | Docker | Kubernetes | Terraform | Ansible | Travis CI | Jenkins | Devops | AWS | GCP | Azure | Solidity | Ethereum Dapp | Blockchain enthusiast",
  skills: [
    emoji(
      "⚡ Develop highly interactive and production level MERN stack websites which are capable of being scaled upto thousands of live users ."
    ),
    emoji("⚡ Experience working on multiple cloud platforms . Hosting and maintaining websites on virtual machine instances along with integration of databases ."),
    emoji(
      "⚡ Develop decentralized applications on the Ethereum blockchain and also create custom blockchain implementations ."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "react",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Mongodb",
      fontAwesomeClassname: "cib-mongodb"
    },
    {
      skillName: "kubernetes",
      fontAwesomeClassname: "cib-kubernetes"
    },
    {
      skillName: "travis-ci",
      fontAwesomeClassname: "cib-travisci"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "terraform",
      fontAwesomeClassname: "cib-terraform"
    },
    {
      skillName: "google-cloud",
      fontAwesomeClassname: "cib-google-cloud"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Thapar Institute Of Engineering and Technology",
      logo: require("./assets/images/thaparlogo.png"),
      subHeader: "Bachelors of Technology in Computer Science",
      duration: "August 2019 - April 2023",
      desc: "I currenntly have a CPGA of 10.0 and I rank among the top 20 students in the college based on the CGPA.",
      descBullets: [
        "Received a scholarship worth 3.18 Laks/annum for a period of 3 years",
        "Learned MERN stack web developement , Blockchain developement as well as explored devops during the course of these 4 years"
      ]
    },
    {
      schoolName: "City Montessori School",
      logo: require("./assets/images/cmsLogo.jpg"),
      subHeader: "Class 12th Boards",
      duration: "September 2013 - April 2017",
      desc:
        "Secured All India Rank 4 with a percentage of 99.25% in my class 12th ISC boards .",
      descBullets: ["Won over 30 competitions in the fields of General Knowedge , Science , Computing and Robotics"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Web Developement (MERN Stack)", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Devops and Cloud Computing",
      progressPercentage: "70%"
    },
    {
      Stack: "Blockchain Dapp Developement",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Research Intern",
      company: "SAMSUNG PRISM",
      companylogo: require("./assets/images/samsungLogo.png"),
      date: "May 2021 – Present",
      desc:
        "Research Intern at the Samsung Prism program 2020 . I worked on the project of Online Tracking Protection Evaluation Tool for a period of six months",
      descBullets: [
        "Several browsers and add-ons provide tracking protection measures and claim to protect user from such trackers.",
        "However there is no universal evaluation framework which can automatically verify how  much protection such solution is actually providing."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Growth Gear",
      companylogo: require("./assets/images/growthgearLogo.png"),
      date: "December 2020 – May 2021",
      desc:
        "Completed the RTC realtime video streaming and video calling module . Both client side and server side using WebRTC ",
      descBullets: [
        "Configured role based access server side.",
        "Completed realtime messaging module which included public and private chats , polls and Q&A .I also integrated it with video calling and streaming module ."
      ]
    },
    // {
    //   role: "Core Member",
    //   company: "Developer Student Club TIET",
    //   companylogo: require("./assets/images/dsctietLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    {
      role: "General Secretary",
      company: "ACM Thapar Chapter",
      companylogo: require("./assets/images/acmLogo.png"),
      date: "August 2019 – Present",
      desc:
        "I served as the General Secretary of ACM thapar Student Chapter . Being at the topmost position in the hierarchy this  was a matter of great prestige for me . Some key duties were :",
      descBullets: [
          "Manage the overall functionaing of the society and guide the executive board as to how they can work efficiently .",
          "Represent the society in Internatiinal conferences and events and be the official spokesperson of the society. "
        ]
  
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Presenting my amazing work",
  projects: [
    {
      image: require("./assets/images/jeevanLogo.png"),
      projectName: "Jeevan - Organ Donation Blockchain",
      projectDesc: "This project aims to  build an ecosystem where the donors , recipients and others can interact with each other directly on secure lines to make the entire procedure more fluid and secure.",
      footerLink: [
        {
          name: "Visit Repository",
          url: "https://github.com/DECODE25/organ-donation-blockchain"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Eventengage_Logo.png"),
      projectName: "Eventengage",
      projectDesc: "Virtual Event app which supports realtime video streaming and realtime chats . I completed this project under the guidance of GrowthGear Ltd . This project uses realtime web socket and webRTC connections .",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://eventengage.netlify.app/lobby"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "All India Rank 4 ISC 2019 scoring 99.25%",
      subtitle:
        "Secured a All India Rank 4 in my ISC 2019 (class 12th) examination among 12 lakh students .",
      image: require("./assets/images/cisce_logo.webp"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1BNJK3LzsN8oN9tkfu-iSHUpBfT1j6gVo/view?usp=sharing"
        },
      ]
    },
    {
      title: "2nd Runner Up in MLH Execute Hackathon",
      subtitle:
        "My team D_CODE secured the third position in the MLH Execute Hackathon for the project jeevan.",
      image: require("./assets/images/mlh_logo.png"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1xLxeS4GIjDckbEJVeYdSFSDF5kEdI2Oc/view?usp=sharing"
        }
      ]
    },

    {
      title: "Google Quicklabs Cloud Engineering Track",
      subtitle: "Completed Certifcation from Google Quicklabs for the Google Cloud Platform cloud engineering track",
      image: require("./assets/images/google_cloud_logo.png"),
      footerLink: [
        {name: "Certification", url: "https://www.qwiklabs.com/public_profiles/ef9b82a7-6466-4d00-9eed-491ab05119fc"},
        {
          name: "Final Project",
          url: "https://www.qwiklabs.com/public_profiles/ef9b82a7-6466-4d00-9eed-491ab05119fc"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and some other companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Introduction to Git and Github",
      subtitle: "At ACM TIET",
      slides_url: "https://youtu.be/AwRTu3SL1ts",
      event_url: "https://youtu.be/AwRTu3SL1ts"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-6387406090",
  email_address: "agarwalujjwal012@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
